import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  TextField,
} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';

export function PlaceForm({
  errors,
  place,
  Controller,
  control,
  materialType,
}) {
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={place ? place.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อคลัง"
              fullWidth
              size={'small'}
              required
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name="address"
          control={control}
          defaultValue={place?.address ?? []}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControl fullWidth size="small" error={!!errors.address}>
              <InputLabel>ประเภทสินค้า</InputLabel>
              <Select
                {...field}
                multiple
                label="ประเภทสินค้า"
                value={field.value || []}
                onChange={(event) => field.onChange(event.target.value)}
                renderValue={(selected) =>
                  _map(
                    materialType?.filter((item) => selected.includes(item._id)),
                    'name',
                  ).join(', ')
                }
              >
                {_map(materialType, (item) => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.address && (
                <FormHelperText>กรุณาใส่ข้อมูล</FormHelperText>
              )}
            </FormControl>
          )}
        />
      </div>
    </div>
  );
}

PlaceForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    address: PropTypes.object,
  }),
  place: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

PlaceForm.defaultProps = {
  place: null,
};

export default PlaceForm;
